/* Custom elements also initialize when Shopify replaces a section in the editor. */
if (!customElements.get('denali-features')) {
  customElements.define('denali-features', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-description-toggle]');
        if (toggle) {
          const description = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
          const expanded = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? '−' : '+';
          description.hidden = !expanded;
        }
      }, { signal });
      const videos = this.querySelectorAll('video');
      videos.forEach((video) => {
        video.addEventListener('error', () => {
          const fallback = video.closest('article').querySelector('[data-video-fallback]');
          if (fallback) { fallback.hidden = false; video.hidden = true; }
        }, { signal });
      });
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting && !document.hidden && !reducedMotion) this.playVideo(target);
            else target.pause();
          });
        }, { threshold: 0.15 });
        videos.forEach((video) => this.observer.observe(video));
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) videos.forEach((video) => video.pause());
      }, { signal });
    }
    playVideo(video) {
      video.muted = true;
      video.play().catch(() => { /* Keep the poster visible when autoplay is blocked. */ });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.querySelectorAll('video').forEach((video) => video.pause());
    }
  });
}

if (!customElements.get('denali-video-reviews')) {
  customElements.define('denali-video-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.frame = this.dialog.querySelector('iframe');
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-youtube-url]');
        if (trigger) {
          const id = this.youtubeId(trigger.dataset.youtubeUrl);
          if (!id) return;
          this.opener = trigger;
          this.frame.title = trigger.getAttribute('aria-label');
          this.frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
          this.dialog.showModal();
        }
        if (event.target.closest('[data-dialog-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.frame.removeAttribute('src');
        this.opener?.focus();
      }, { signal });
      this.querySelectorAll('[data-youtube-url]').forEach((button) => {
        if (!this.youtubeId(button.dataset.youtubeUrl)) button.disabled = true;
      });
    }
    youtubeId(value) {
      try {
        const url = new URL(value);
        if (!['https:', 'http:'].includes(url.protocol)) return null;
        const host = url.hostname.toLowerCase().replace(/^www\./, '');
        let id;
        if (host === 'youtu.be') id = url.pathname.split('/')[1];
        else if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)) {
          id = url.searchParams.get('v');
          if (!id && /^\/(embed|shorts|live)\//.test(url.pathname)) id = url.pathname.split('/')[2];
        }
        return /^[\w-]{11}$/.test(id || '') ? id : null;
      } catch (_) { return null; }
    }
    disconnectedCallback() {
      this.frame?.removeAttribute('src');
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

if (!customElements.get('denali-product-cards')) {
  customElements.define('denali-product-cards', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      // Existing product-form reports API errors; provide a message for network failures too.
      this.addEventListener('on:cart:error', (event) => {
        const error = event.target.querySelector('.js-form-error');
        if (error && !error.textContent.trim()) {
          error.textContent = this.dataset.errorMessage;
          error.hidden = false;
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
